<template>
    <div class="wrap wrap--sub">
        <!-- 헤더 -->
        <main-header />

        <!-- 메인 -->
        <main class="main" role="main">
            <div class="collection-index-container">
                <div class="page-head">
                    <div class="page-head__inner">
                        <h1 class="page-head__title">{{ collection.name }}</h1>
                        <ul class="breadcrumb">
                            <li class="breadcrumb__list" v-for="crumb in crumbs" :key="crumb">{{ crumb }}</li>
                        </ul>
                    </div>
                </div>
                <!-- <div class="page-head">
                    <div class="page-head__inner">
                        <h1 class="page-head__title">SAVOY</h1>
                        <ul class="breadcrumb">
                            <li class="breadcrumb__list">Home</li>
                            <li class="breadcrumb__list">COLLECTION_3</li>
                            <li class="breadcrumb__list">SAVOY</li>
                        </ul>
                    </div>
                </div> -->

                <div class="container">
                    <div class="index-container index-container-en">
                        <div class="index-wrapper">
                            <div v-for="({ code, name, thumb }, index) in products" :key="`products-${index}`" class="index-items">
                                <!-- index-slide--selected 클래스 추가 시 스타일 변경됩니다. -->
                                <a :href="`${$route.path}/${code}`" class="index-slide">
                                    <span class="thumbnail" :style="`background-image: url(/res/shop/products/${thumb});`"></span>
                                    <span class="name">{{ name }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="container">
                    <div class="index-container index-container-en">
                        <div class="index-wrapper">
                            <div class="index-items">
                                <div role="button" class="index-slide index-slide--selected">
                                    <span class="thumbnail" style="background-image: url();"></span>
                                    <span class="name">JM1001-1</span>
                                </div>
                            </div>
                            <div class="index-items">
                                <div role="button" class="index-slide">
                                    <span class="thumbnail" style="background-image: url();"></span>
                                    <span class="name">JM1001-2</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </main>

        <!-- 푸터 -->
        <main-footer />
    </div>
</template>

<script>
import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";

import CollectionList from "@/components/client/collection/collection-list.vue";

export default {
    components: {
        MainHeader,
        MainFooter,
        CollectionList,
    },
    data() {
        return {
            collection: {},
            products: [],
        };
    },
    computed: {
        crumbs() {
            const getParent = (category, parents) => {
                if (category?.parents?.length) {
                    const parent = category.parents[0];
                    return getParent(parent, [parent.name, ...parents]);
                } else return parents;
            };
            return getParent(this.collection, [this.collection.name]);
        },
        code() {
            return this.$route.params.collectionCode;
        },
    },
    mounted() {
        this.search();
    },
    watch: {
        code() {
            this.search();
        },
    },
    methods: {
        async search() {
            try {
                var {
                    data: { categories },
                } = await this.$http.get("/api/v1/shop/categories", { params: { code: this.code } });
                this.collection = categories[0];

                const { products } = await this.$http.get("/api/v1/shop/products", { params: { _category: this.collection._id } }).then((res) => res.data);
                this.products = products;
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
            }
        },
    },
};
</script>